/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Role_Bound_OtherInputs */

const cs_clients_role_bound_other = /** @type {(inputs: Clients_Role_Bound_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez role-specifického modulu — kontakty, poznámky a štítky.`)
};

const en_clients_role_bound_other = /** @type {(inputs: Clients_Role_Bound_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No role-specific module — use contacts, notes, and tags.`)
};

/**
* | output |
* | --- |
* | "No role-specific module — use contacts, notes, and tags." |
*
* @param {Clients_Role_Bound_OtherInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_role_bound_other = /** @type {((inputs?: Clients_Role_Bound_OtherInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Role_Bound_OtherInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_role_bound_other(inputs)
	return cs_clients_role_bound_other(inputs)
});